module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "licence-uploader"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('title.add-licence')))]), _vm._v(" "), _c('data-form', {
    attrs: {
      "entity": _vm.server,
      "fields": _vm.fields,
      "cancel": false
    },
    on: {
      "submit": _vm.submit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c7457c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/server/LicenceUploader.vue
// module id = 990
// module chunks = 2